module.exports = __webpack_public_path__ + "static/media/iconCanvas10.74fe11e2.svg";